import {
  ApolloClient,
  ApolloLink,
  HttpLink,
  InMemoryCache,
  concat,
  from,
} from "@apollo/client";
import { ApolloProvider } from "@apollo/client/react";
import React, { useMemo } from "react";

import { removeTypenameFromVariables } from "@apollo/client/link/remove-typename";

import { apolloConfig } from "@/config";
import useAppStore from "@/store/use-app-store";

function ApolloContext({ children }) {
  const apolloClient = useMemo(() => {
    const removeTypenameLink = removeTypenameFromVariables();
    const httpLink = new HttpLink({
      uri: apolloConfig.uri,
    });

    const authLink = new ApolloLink((operation, forward) => {
      if (!useAppStore.getState().token && !operation?.variables?.adminToken)
        return forward(operation);
      if (operation?.variables?.adminToken) {
        operation.setContext({
          headers: {
            authorization: `Bearer ${operation?.variables?.adminToken}`,
          },
        });
      } else {
        operation.setContext(({ headers = {} }) => ({
          headers: {
            ...headers,
            authorization: `Bearer ${useAppStore.getState().token ?? ""}`,
          },
        }));
      }
      return forward(operation);
    });

    const link = from([removeTypenameLink, concat(authLink, httpLink)]);

    return new ApolloClient({
      cache: new InMemoryCache({}),
      clientAwareness: {
        name: "web",
        version: "1.0",
      },
      link: link,
    });
  }, []);

  return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>;
}

export { ApolloContext };
